// Central business config — replace placeholders with real data anytime.
export const site = {
  name: "Schlüsseldienst Wien Pro",
  legalName: "Schlüsseldienst Wien Pro",
  // TODO: Telefonnummer wird nachgereicht
  phone: "",
  phoneDisplay: "Telefon folgt in Kürze",
  phoneHref: "mailto:schluesselmonteur@gmail.com",
  whatsapp: "",
  whatsappHref: "mailto:schluesselmonteur@gmail.com",
  email: "schluesselmonteur@gmail.com",
  address: "Annagasse 5, 1010 Wien",
  street: "Annagasse 5",
  postalCode: "1010",
  city: "Wien",
  country: "AT",
  url: "https://schluesseldienstwien24.com",
  rating: 4.9,
  reviewCount: 1247,
  priceRange: "€€",
  hours: "Mo–So 0:00–24:00",
};